import React, { useState, useEffect } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { Box } from '@mui/material';
import DesignsComponent from '../components/DesignsComponent';
import PublishCard from '../components/PublishCard';
import Mockups from '../components/Mockups';

const Designs = () => {
  const [designData, setDesignData] = useState(null);
  const location = useLocation();
  const navigate = useNavigate();

  useEffect(() => {
    if (location.state?.design) {
      setDesignData(location.state.design);
    }
  }, [location.state]);

  const changeToMockups= (data) => {
    navigate('/mockups', { state: { 
      image_url_to_mockups: data.image_url_to_mockups, 
      prompt_to_mockups: data.prompt_to_mockups,
      dalle_image: data.dalle_image 
    }});
  };

  return (
    <Box sx={{ width: '100%' }}>
      <h1>Designs</h1>
      <p>To get started, describe what you want to sell in the box below...</p>
      <DesignsComponent initialDesignData={designData} onChangeToMockups={changeToMockups} />
    </Box>
  );
};

export default Designs;
